import { useMemo } from 'react';

import { useCustomSkillTaxonomyTree } from '../../../../../../shared/selection-lists/hooks/useCustomSkillTaxonomyTree';
import { treeToCustomSkillSelectionLists } from '../../../../../../shared/selection-lists/utils/treeToCustomSkillSelectionLists';

// The custom-skill granularities the report builder exposes today (k150 →
// k5000). treeToCustomSkillSelectionLists is level-count agnostic, so offering
// deeper skills (e.g. k15000) is just a matter of widening this allow-list.
const REPORT_CUSTOM_SKILL_LIST_IDS = new Set([
  'custom_skill_k150',
  'custom_skill_k1500',
  'custom_skill_k5000',
]);

/**
 * Builds per-level Custom Skill selection lists for the BreadcrumbTree from the
 * skill TaxonomyTree (the same version-resolved tree the rest of the app reads),
 * replacing the legacy `SpecificCustomSkills` selection-list query.
 */
export const useReportsCustomSkills = (taxonomyId: number) => {
  const { treeData, levels, isCustomSkillTaxonomyPending } =
    useCustomSkillTaxonomyTree(taxonomyId);

  const lists = useMemo(
    () =>
      treeToCustomSkillSelectionLists(treeData, levels).filter((list) =>
        REPORT_CUSTOM_SKILL_LIST_IDS.has(list.id)
      ),
    [treeData, levels]
  );

  return { lists, isLoading: isCustomSkillTaxonomyPending };
};
